import { OverboxScannedParcelSchema } from "@redotech/redo-model/fulfillments/shipment-leg";
import { shipmentLegIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const OverboxServiceSchema = z.enum(["apc", "epg"]);
const OverboxCarrierSchema = z.enum(["fedex", "ups", "dhl"]);

export const purchaseOverboxLabel = {
  name: "purchaseOverboxLabel" as const,
  input: z.object({
    service: OverboxServiceSchema,
    carrier: OverboxCarrierSchema,
    parcel: z.object({
      lengthInches: z.number().positive(),
      widthInches: z.number().positive(),
      heightInches: z.number().positive(),
      weightOunces: z.number().positive(),
    }),
    /**
     * Inner parcels scanned into the box before printing. Required for the
     * v2 scan-to-build-box flow; omitted (or empty) by the v1 fast-print
     * page, in which case the handler buys the label without persisting a
     * leg or registering a tracker.
     */
    contents: z.array(OverboxScannedParcelSchema).optional(),
  }),
  output: z.object({
    labelUrl: z.string(),
    trackingNumber: z.string(),
    /** Present only on the v2 path. */
    shipmentLegId: shipmentLegIdFormat.schema.nullable(),
  }),
};
